export default "/images/44b33903c2a3b72e2cd25a898fd6f6cc.avif";